import http, { noneTokenHttp } from "../utils/http";
import jwt from "jsonwebtoken";
import { getUsers } from "../apis/users";
import { get } from "lodash";
import systemAlert from "../utils/systemAlert";

// REDUX 로 호출
const login = ({ id, password }) => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post(`/auth`, { id, password, device: 'WECAKE_WEB' })
      .then((response) => {
        const { accessToken, refreshToken } = response.data;
        // jwt decode - userIdx payload 호출
        const decoded = jwt.decode(accessToken);
        const { userIdx } = decoded;
        // 토큰 세팅
        setSession({ accessToken, refreshToken });
        // 본인 정보 세팅
        getUsers(userIdx)
          .then((res) => {
            const user = get(res, "data.user")
            setUser(user);
            resolve(user);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// tokenRefresh
export const tokenRefresh = () => {
  return new Promise((resolve, reject) => {
    noneTokenHttp
      .post(`/auth/refresh`, { refreshToken: getRefreshToken() })
      .then((response) => {
        const { accessToken, refreshToken } = response.data;
        setSession({ accessToken, refreshToken });
        resolve(true)
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// Logout REDUX 로 분리

const sessionClear = () => {
  setSession()
  localStorage.removeItem("user");
  localStorage.removeItem("companyToken");
  localStorage.clear();
};

const setSession = ({ accessToken, refreshToken } = {}) => {
  if (accessToken && refreshToken) {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  } else {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }
};

export const getCompanyTokenInfo = () => {
  const companyToken = getCompanyToken()
  const companyInfo = jwt.decode(companyToken);
  return companyInfo || {}
}

export const getAccessTokenInfo = () => {
  const accessToken = getAccessToken()
  const accessInfo = jwt.decode(accessToken);
  return accessInfo || {}
};


const getCompanyToken = () => {
  return window.localStorage.getItem("companyToken");
};

const getAccessToken = () => {
  return window.localStorage.getItem("accessToken");
};

const getRefreshToken = () => {
  return window.localStorage.getItem("refreshToken");
};

const setUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

const getUser = () => {
  let user = localStorage.getItem("user");
  if (user) user = JSON.parse(user);
  if (!user) user = "";
  return user;
};

const setVersion = (version) => {
  return window.localStorage.setItem("APP_VERSION", version);
};

const getVersion = () => {
  return window.localStorage.getItem("APP_VERSION");
};

const allAuthExpire = () => {
  return new Promise((resolve, reject) => {
    const info = getAccessTokenInfo()
    http
      .post(`/auth/expire`, {
        "userIdxes": [
          info.userIdx
        ]
      })
      .then((res) => {
        systemAlert('해당 계정 전체 로그아웃 되었습니다.\n 다시 로그인해주세요.')
        window.location.href = '/logout'
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export {
  login,
  setSession,
  sessionClear,
  setUser,
  getUser,
  getCompanyToken,
  getAccessToken,
  getRefreshToken,
  setVersion,
  getVersion,
  allAuthExpire,
};
